module.exports = __webpack_public_path__ + "64e4256371f4d68f773d289ce0dbcba8.svg";